module.exports = __webpack_public_path__ + "static/media/chart-arrow-forward-disabled.ef4773c7.svg";